import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";
import BlueBar from "../../commons/blueBar";
// Styles
import "../../../assets/saas/organisms/_search-popup.scss";
const ModalPopUpTarget = (modalPropsTarget) => {
    const initialscrollBody = document.body.style.overflow;
    const { t, i18n } = useTranslation();
    useEffect(() => {
        var _a, _b, _c;
        if (document.getElementById("date-picker-modal-hide")) {
            const shouldAddClass = document.getElementById("time-picker-modal-hide") &&
                !document.getElementById("search_popup");
            if (shouldAddClass) {
                document.body.classList.remove("body-block-scroll");
            }
            else {
                document.body.classList.add("body-block-scroll");
            }
        }
        else {
            (_a = document
                .getElementsByClassName("shopify-section-group-header-group")[0]) === null || _a === void 0 ? void 0 : _a.classList.add("hidden");
            (_b = document
                .getElementsByClassName("header-wrapper")[0]) === null || _b === void 0 ? void 0 : _b.classList.add("hidden");
            (_c = document.getElementById("chat")) === null || _c === void 0 ? void 0 : _c.classList.add("hidden");
            document.body.classList.add("noscroll");
            return () => {
                document.body.style.overflow =
                    initialscrollBody === "hidden" ? "auto" : initialscrollBody;
            };
        }
    });
    const handleClose = () => {
        var _a, _b, _c;
        if (document.getElementById("time-picker-modal")) {
            const hoursOptionsPick = document.querySelector(".hours_options_pick");
            const hoursOptionsDrop = document.querySelector(".hours_options_drop");
            const timeOptions = hoursOptionsPick === null || hoursOptionsPick === void 0 ? void 0 : hoursOptionsPick.querySelectorAll(".hour_option_container");
            const timeOptionsDrop = hoursOptionsDrop === null || hoursOptionsDrop === void 0 ? void 0 : hoursOptionsDrop.querySelectorAll(".hour_option_container");
            timeOptions === null || timeOptions === void 0 ? void 0 : timeOptions.forEach((timeOption) => {
                timeOption.classList.remove("active_hour");
            });
            setTimeout(() => {
                var _a, _b;
                (_b = document
                    .getElementById((_a = modalPropsTarget.pickOption) !== null && _a !== void 0 ? _a : "pick_option_24")) === null || _b === void 0 ? void 0 : _b.classList.add("active_hour");
            }, 50);
            timeOptionsDrop === null || timeOptionsDrop === void 0 ? void 0 : timeOptionsDrop.forEach((timeOption) => {
                timeOption.classList.remove("active_hour");
            });
            setTimeout(() => {
                var _a, _b;
                (_b = document
                    .getElementById((_a = modalPropsTarget.dropOption) !== null && _a !== void 0 ? _a : "pick_option_24")) === null || _b === void 0 ? void 0 : _b.classList.add("active_hour");
            }, 50);
        }
        if (window.location.href.includes("collections")) {
        }
        else {
            document.body.classList.remove("noscroll");
        }
        modalPropsTarget.setModalShow(false);
        (_a = document
            .getElementsByClassName("shopify-section-group-header-group")[0]) === null || _a === void 0 ? void 0 : _a.classList.remove("hidden");
        (_b = document
            .getElementsByClassName("header-wrapper")[0]) === null || _b === void 0 ? void 0 : _b.classList.remove("hidden");
        (_c = document.getElementById("chat")) === null || _c === void 0 ? void 0 : _c.classList.remove("hidden");
    };
    const visible = "visible";
    const [styleModal, setStyleModal] = useState({
        visibility: visible,
        opacity: 1,
        zIndex: 9999,
    });
    const modalRoot = document.getElementsByTagName("body")[0];
    return ReactDOM.createPortal(_jsxs("div", { id: modalPropsTarget.id, className: "search-popup overlay", style: styleModal, children: [_jsx(BlueBar, { onclick: () => {
                    handleClose();
                }, customId: "blue-bar-reservation", t: t }), _jsx("div", { className: modalPropsTarget.id === "search_popup" ||
                    modalPropsTarget.id === "time-picker-modal"
                    ? "popup opening noscroll"
                    : "popup opening ", children: _jsx("div", { className: "car_reservation", children: _jsxs("div", { className: "booking_card", children: [modalPropsTarget.title && (_jsx("div", { className: "card_heading", children: _jsx("h3", { className: "small-heading-h5 weight-800", children: modalPropsTarget.title }) })), _jsx("div", { id: "body-modal", children: modalPropsTarget.children })] }) }) })] }), modalRoot);
};
export default ModalPopUpTarget;
